export default __webpack_public_path__ + "static/media/BCLager.ca03b95a.webp";